import { Link } from 'react-router-dom';

interface HeroProps {
  title: string;
  subtitle: string;
  description: string;
  ctaLabel: string;
  ctaUrl: string;
  heroImage: string;
}

export default function HeroSection({ title, subtitle, description, ctaLabel, ctaUrl, heroImage }: HeroProps) {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src={heroImage}
        alt={`${title} - ${subtitle}`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-white/70 text-sm md:text-base tracking-[0.2em] uppercase font-label mb-4 animate-fadeIn opacity-0">
          {subtitle}
        </h2>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-fadeIn opacity-0 delay-200">
          {title}
        </h1>
        <p className="text-white/80 text-sm md:text-base max-w-2xl mx-auto leading-relaxed mb-8 animate-fadeIn opacity-0 delay-300">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-slideUp opacity-0 delay-400">
          <a
            href={ctaUrl}
            target="_blank"
            rel="nofollow noreferrer"
            className="px-8 py-3 bg-primary-500 text-white font-semibold rounded-full text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            {ctaLabel}
          </a>
          <Link
            to="/about"
            className="px-8 py-3 border border-white/30 text-white font-medium rounded-full text-sm hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}